<!--
  FGA Unauthorized Component Template

  Displays access denied screen with options to request access or retry.
  Follows WCAG 2.2 accessibility guidelines.
-->

<section
  class="fga-unauthorized"
  role="alert"
  aria-live="assertive"
  aria-labelledby="unauthorized-title"
  aria-describedby="unauthorized-message"
>
  <!-- Lock Icon (Decorative) -->
  <div class="fga-unauthorized__icon" aria-hidden="true">
    <i class="ds-ngkit ds-ngkit-lock"></i>
  </div>

  <!-- Title -->
  <h1 id="unauthorized-title" class="fga-unauthorized__title">
    Access Denied
  </h1>

  <!-- Error Message (hidden by default) -->
  @if (showErrorMessage) {
    <p id="unauthorized-message" class="fga-unauthorized__message">
      {{ errorState.errorMessage() }}
    </p>
  }

  <!-- Error Source (hidden by default) -->
  @if (showErrorSource && shouldShowSource()) {
    <p class="fga-unauthorized__source">
      Source: {{ getSourceDisplay() }}
    </p>
  }

  <!-- Help Text -->
  <p class="fga-unauthorized__help">
    Please contact your administrator to request access.
  </p>

  <!-- Action Buttons (hidden by default) -->
  @if (showActionButtons) {
    <div class="fga-unauthorized__actions">
      <p-button
        styleClass="ngkit-button ngkit-button-primary"
        label="Request Access"
        icon="ds-ngkit ds-ngkit-login"
        data-testid="request-access-btn"
        (click)="onRequestAccess()"
      ></p-button>

      <p-button
        styleClass="ngkit-button ngkit-button-secondary"
        [outlined]="true"
        label="Retry"
        icon="ds-ngkit ds-ngkit-refresh"
        data-testid="retry-btn"
        (click)="onRetry()"
      ></p-button>
    </div>
  }
</section>
